import { render } from "./CardRecord.vue?vue&type=template&id=74dbcd47"
import script from "./CardRecord.vue?vue&type=script&lang=js"
export * from "./CardRecord.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__